import { INSTANCES } from './constants';
import { getEnvConfig } from './get-env-config';

const config = getEnvConfig();

export const isHC = config.HACKETT_USER_AUTH_INSTANCE === INSTANCES.HC;
export const isQL = config.HACKETT_USER_AUTH_INSTANCE === INSTANCES.QL;

export default config;
